import { BlogUserBanPopupComponent } from './blog-user-ban-popup/blog-user-ban-popup.component';
import { BlogDataService } from './../../data/repository/blog-repository/blog-data.service';
import { SetUsernameBottomsheetComponent } from './set-username-bottomsheet/set-username-bottomsheet.component';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { MatDialog } from '@angular/material/dialog';
import {
  Component,
  OnInit,
  OnDestroy,
  HostListener,
  ElementRef,
  ViewChild,
} from '@angular/core';
import { BlogPostModel } from 'src/app/core/model/object/blog-model';
import { Subscription, interval, Observable } from 'rxjs';
import { BlogShared } from '../general/shared/blog-shared';
import { BlogService } from 'src/app/data/repository/blog-repository/blog.service';
import { LoadingShared } from '../general/shared/loading-shared';
import { SnackBarService } from 'src/app/data/repository/utils-repository/snack-bar.service';
import { PopupShared } from '../general/shared/popup-shared';
import { TabBarShared } from '../general/shared/tab-bar-shared';
import { TribuneAnalyticsService } from 'src/app/data/repository/analytics-repository/tribune-analytics.service';
import { BlogUserModel } from 'src/app/core/model/object/blog-user-model';
import { BlogUserService } from 'src/app/data/repository/blog-repository/blog-user.service';

@Component({
  selector: 'app-blog',
  templateUrl: './blog.component.html',
  styleUrls: ['./blog.component.scss'],
})
export class BlogComponent implements OnInit, OnDestroy {
  @ViewChild('scrollTop') private myScrollContainer: ElementRef<HTMLDivElement>;

  id = 10;
  dataIsReady = false;
  showBlogWithTag = false;
  showDetail = false;
  showSearch = false;
  showProfile = false;
  showActivity = false;
  showSuggest = false;
  showCreatePost = false;
  selectedPost: BlogPostModel;
  posts: BlogPostModel[];
  postsCount = 0;
  postsPage = 0;
  postPerPage = 10;
  detailId = 10;
  searchId = 10;
  tagId = 10;
  profileId = 10;
  activityId = 10;
  selectedUsername = '';
  activityCount = 0;
  lastScroll: number = 0;

  midDivScrollTop = 0;
  lastScrollTop = 0;
  midDivHeight = 0;
  postsPosition = [];
  lastPostHeight = 0;
  suggestionPosition = 100;
  loadImage = [];
  loadSuggestion = false;
  usedDataScroll = false;
  user: BlogUserModel;
  suggestedUsers: BlogUserModel[];
  allSuggestedUsers: BlogUserModel[];

  subscription1: Subscription;
  subscription2: Subscription;
  subscription3: Subscription;
  subscription4: Subscription;
  subscription5: Subscription;
  subscription6: Subscription;
  subscription7: Subscription;
  subscription8: Subscription;
  subscription9: Subscription;
  subscription10: Subscription;
  subscription11: Subscription;

  constructor(
    public blogShared: BlogShared,
    private blogService: BlogService,
    private loadingShared: LoadingShared,
    private snackBarService: SnackBarService,
    private popupShared: PopupShared,
    private tabBarShared: TabBarShared,
    private tribuneAnalytics: TribuneAnalyticsService,
    private blogUserService: BlogUserService,
    private matBottomSheet: MatBottomSheet,
    private blogDataService: BlogDataService,
    private dialog: MatDialog
  ) {
    this.subscription1 = this.blogShared.blogTabSelectedObs$.subscribe(
      (clicked) => {
        if (clicked) {
          this.tribuneAnalytics.analyticTribuneVisited();
          this.loadPage();
          this.lastScroll = this.blogDataService.getLastScroll();
          this.postsPage = this.blogDataService.getPostLoaded();
        }
      }
    );
    this.subscription2 = this.blogShared.blogOpenDetailObs$.subscribe((res) => {
      if (res.id === this.id.toString()) {
        for (let i = 0; i < this.posts.length; i++) {
          if (this.posts[i].id === res.postId) {
            this.openDetail(i);
          }
        }
      }
    });
    this.subscription3 = this.blogShared.blogOpenDetailCommentsObs$.subscribe(
      (res) => {
        if (res.id === this.id.toString()) {
          for (let i = 0; i < this.posts.length; i++) {
            if (this.posts[i].id === res.postId) {
              this.openDetailComments(i);
            }
          }
        }
      }
    );
    this.subscription4 = this.blogShared.openBlogWithTagObs$.subscribe((id) => {
      if (id === this.id) {
        this.openBlogWithTag();
      }
    });
    this.subscription5 = this.popupShared.confirmSendPopupObs$.subscribe(
      (confirm) => {
        if (confirm) {
          this.profile(this.user.userName);
        }
      }
    );
    this.subscription6 = this.blogShared.blogCloseProfileObs$.subscribe(
      (close) => {
        if (close) {
          this.closeProfile();
        }
      }
    );
    this.subscription7 = this.blogShared.blogOpenProfileObs$.subscribe(
      (open) => {
        if (open) {
          this.profile(this.blogShared.getSelectedUsername());
        }
      }
    );
    this.subscription8 = this.blogShared.closeCreatePostObs$.subscribe(
      (close) => {
        if (close) {
          this.closeCreatePost();
        }
      }
    );
    this.subscription11 =
      this.blogShared.closeAndUpdateCreatePostObs$.subscribe((close) => {
        if (close) {
          this.refresh();
          this.closeCreatePost();
        }
      });
    this.subscription9 = this.blogShared.removePostPopupActionObs$.subscribe(
      (remove) => {
        if (remove && this.blogShared.selectedRemovingPostId !== '') {
          this.loadingShared.showLoading();
          this.blogService
            .deletePost(this.blogShared.selectedRemovingPostId)
            .then((res) => {
              if (res.isSuccess()) {
                let index = -1;
                this.posts.forEach((post, i) => {
                  if (post.id === this.blogShared.selectedRemovingPostId) {
                    index = i;
                  }
                });
                this.posts.splice(index, 1);
                this.blogShared.removePost();
              } else {
                this.snackBarService.showSnackBar(
                  'خطا در برقراری ارتباط با سرور!'
                );
              }
              this.loadingShared.hideLoading();
            });
        }
      }
    );
    this.subscription10 = this.blogShared.usernameChangeObs$.subscribe(
      (changed) => {
        if (changed) {
          this.user.userName = this.blogShared.newUsername;
        }
      }
    );
  }

  ngOnInit() {}
  async ScrollToSourcePost(
    posts: BlogPostModel[],
    loaded: number,
    scroll: number
  ) {
    // this.loadingShared.showLoading();
    this.postsPage = loaded;
    // this.blogService
    //   .getBlogPosts(loaded, this.postPerPage)
    //   .then(async (res) => {
    // if (res.isSuccess()) {
    // this.analyticTribuneNewPageLoaded();
    // console.log(res.getData().getBlogList().posts);

    this.posts = posts;
    this.postsCount = posts.length;
    await this.blogService.getUserSuggestions().then((result) => {
      if (result.isSuccess()) {
        this.allSuggestedUsers = result.getData().getBlogUsers();
        this.suggestedUsers = this.allSuggestedUsers.slice(
          0,
          Math.min(10, this.allSuggestedUsers.length)
        );
      }
    });
    await this.blogUserService.getBlogUser().then(async (result) => {
      this.user = result;
      await this.blogActivityCount();
      this.scrollTop();
      this.dataIsReady = true;
      setTimeout(() => {
        this.getPostsPosition(true);
      }, 100);
    });
    this.scrollTo(scroll);
    // } else {
    //   this.snackBarService.showSnackBar('خطا در برقراری ارتباط با سرور!');
    // }
    // this.loadingShared.hideLoading();
    // });
  }
  @HostListener('window:beforeunload')
  ngOnDestroy(): void {
    this.blogDataService.setLoadedPost(this.posts);
    this.subscription1.unsubscribe();
    this.subscription2.unsubscribe();
    this.subscription3.unsubscribe();
    this.subscription4.unsubscribe();
    this.subscription5.unsubscribe();
    this.subscription6.unsubscribe();
    this.subscription7.unsubscribe();
    this.subscription8.unsubscribe();
    this.subscription9.unsubscribe();
    this.subscription10.unsubscribe();
    this.subscription11.unsubscribe();
  }

  scroll(scrollToTop: boolean, force: boolean) {
    this.lastScrollTop = force ? 0 : this.lastScrollTop;
    this.midDivScrollTop = scrollToTop
      ? 0
      : this.myScrollContainer.nativeElement.scrollTop;
    if (Math.floor(this.midDivScrollTop / 200) >= this.lastScrollTop) {
      this.postsPosition.forEach((postPosition, i) => {
        if (
          this.midDivHeight + this.midDivScrollTop >= postPosition &&
          !this.loadImage[i]
        ) {
          this.loadImage[i] = true;
        }
      });
      if (
        this.midDivHeight + this.midDivScrollTop >=
          this.postsPosition[this.postsPosition.length - 1] +
            this.lastPostHeight -
            100 &&
        this.postsCount > (this.postsPage + 1) * this.postPerPage
      ) {
        this.showMorePosts();
      }
      if (
        this.midDivHeight + this.midDivScrollTop >= this.suggestionPosition &&
        !this.loadSuggestion
      ) {
        this.loadSuggestion = true;
      }
      this.lastScrollTop = Math.floor(this.midDivScrollTop / 200) + 1;
      this.blogDataService.setPostLoaded(this.postsPage);
      this.blogDataService.setLastScroll(
        document.getElementById('scroll_area').scrollTop
      );
    }
  }
  scrollTo(scroll: number) {
    const inter = setInterval(() => {
      const el = document.getElementById('scroll_area');
      if (el) {
        el.scrollTop = scroll;
        // console.log(scroll);

        clearInterval(inter);
      }
    }, 400);
  }
  getPostsPosition(scrollToTop: boolean) {
    if (scrollToTop) {
      this.midDivScrollTop = 0;
      this.lastScrollTop = 0;
      this.midDivHeight = 0;
      this.postsPosition = [];
      this.suggestionPosition = 100;
      this.lastPostHeight = 0;
      this.loadSuggestion = false;
      this.loadImage = [];
    }
    const postsPosition = document.getElementsByClassName('appPost');
    for (let i = 0; i < postsPosition.length; i++) {
      const p = postsPosition[i] as HTMLElement;
      this.postsPosition[i] = p.offsetTop;
      const positionInfo = p.getBoundingClientRect();
      this.lastPostHeight = positionInfo.height;
    }
    this.suggestionPosition = this.postsPosition[3] - 197;
    if (this.myScrollContainer?.nativeElement?.offsetHeight)
      this.midDivHeight = this.myScrollContainer.nativeElement.offsetHeight;
    // console.log('postsposition', this.postsPosition, this.suggestionPosition, this.lastPostHeight)
    // console.log('height', this.midDivHeight)
    this.scroll(scrollToTop, true);
  }

  loadPage() {
    if (this.blogDataService.getPostLoaded() == 0) {
      // this.loadingShared.showLoading();
      this.blogShared.followedSuggestedUsernames = [];
      this.blogService.loadPosts(this.postPerPage).then(async (res) => {
        if (res.isSuccess()) {
          this.posts = res.getData().getBlogList().posts;
          this.postsCount = res.getData().getBlogList().count;

          await this.blogService.getUserSuggestions().then((result) => {
            if (result.isSuccess()) {
              this.allSuggestedUsers = result.getData().getBlogUsers();
              this.suggestedUsers = this.allSuggestedUsers.slice(
                0,
                Math.min(10, this.allSuggestedUsers.length)
              );
            }
          });
          this.blogUserService.getBlogUser().then(async (result) => {
            this.user = result;
            await this.blogActivityCount();
            this.scrollTop();
            this.dataIsReady = true;
            setTimeout(() => {
              this.getPostsPosition(true);
            }, 100);
          });

          this.scrollTo(this.blogDataService.getLastScroll());
        } else {
          this.snackBarService.showSnackBar('خطا در برقراری ارتباط با سرور!');
        }
        this.loadingShared.hideLoading();
      });
    } else {
      this.ScrollToSourcePost(
        this.blogDataService.getLoadedPost(),
        this.postsPage,
        this.blogDataService.getLastScroll()
      );
    }
  }

  refresh() {
    this.postsCount = 0;
    this.postsPage = 0;
    this.dataIsReady = false;
    // this.analyticTribuneRefreshed();
    this.loadPage();
  }

  showMorePosts() {
    this.loadingShared.showLoading();
    this.postsPage++;
    this.blogService
      .getBlogPosts(this.postsPage, this.postPerPage)
      .then((res) => {
        if (res.isSuccess()) {
          // this.analyticTribuneNewPageLoaded();
          this.posts = [...this.posts, ...res.getData().getBlogList().posts];
          this.postsCount = res.getData().getBlogList().count;
          setTimeout(() => {
            this.getPostsPosition(false);
          }, 100);
        } else {
          this.snackBarService.showSnackBar('خطا در برقراری ارتباط با سرور!');
        }
        this.loadingShared.hideLoading();
      });
  }

  blogActivityCount() {
    this.blogService.getActivityCount().then((res) => {
      if (res.isSuccess()) {
        this.activityCount = res.getData().getBlogActivityList().count;
        if (this.activityCount > 0) {
          this.blogShared.showBlogNotification();
        } else {
          this.blogShared.hideBlogNotification();
        }
      }
    });
  }

  checkUserBanStatus() {
    return true;
  }

  search() {
    if (this.checkUserBanStatus()) {
      this.blogService.goToSearch();
    }
    // this.blogShared.blogZIndex++;
    // this.searchId = this.blogShared.blogZIndex;
    // this.tabBarShared.hideTabBar();
    // this.showSearch = true;
    // setTimeout(() => {
    //   document.getElementById('searchPage').style.zIndex =
    //     this.blogShared.blogZIndex.toString();
    //   document.getElementById('searchPage').style.right = '0';
    // }, 100);
  }

  closeSearch() {
    this.blogShared.blogZIndex--;
    document.getElementById('searchPage').style.right = '100%';
    setTimeout(() => {
      this.tabBarShared.showTabBar();
      this.showSearch = false;
    }, 300);
  }

  profile(username: string) {
    if (username === '') {
      this.checkUsername();
    } else {
      if (this.checkUserBanStatus()) {
        this.blogService.goToUserProfile(username);
        this.tabBarShared.hideTabBar();
      }
      // this.selectedUsername = username;
      // this.blogShared.blogZIndex++;
      // this.profileId = this.blogShared.blogZIndex;
      // this.showProfile = true;
      // setTimeout(() => {
      //   // document.getElementById('profilePage' + this.id).style.zIndex =
      //   //   this.blogShared.blogZIndex.toString();
      //   // document.getElementById('profilePage' + this.id).style.right = '0';
      //   this.blogService.goToUserProfile(this.selectedUsername, this.id);
      //   console.log('here');
      // }, 100);
    }
  }

  closeProfile() {
    this.blogShared.blogZIndex--;
    document.getElementById('profilePage' + this.id).style.right = '100%';
    // this._sharedService.animateDownButton();
    if (this.blogShared.blogZIndex === 10) {
      this.blogUserService.getBlogUser().then((result) => {
        this.user = result;
      });
    }
    setTimeout(() => {
      if (this.blogShared.blogZIndex === 10) {
        this.tabBarShared.showTabBar();
      }
      this.showProfile = false;
    }, 300);
  }

  activity() {
    if (this.checkUserBanStatus()) {
      this.blogService.goToActivity();
    }
    // this.blogShared.blogZIndex++;
    // this.activityId = this.blogShared.blogZIndex;
    // this.tabBarShared.hideTabBar();
    // this.showActivity = true;
    // setTimeout(() => {
    //   document.getElementById('activityPage').style.zIndex =
    //     this.blogShared.blogZIndex.toString();
    //   document.getElementById('activityPage').style.right = '0';
    // }, 100);
  }

  closeActivity() {
    this.blogShared.blogZIndex--;
    document.getElementById('activityPage').style.right = '100%';
    this.blogActivityCount();
    // this._sharedService.animateDownButton();
    setTimeout(() => {
      this.tabBarShared.showTabBar();
      this.showActivity = false;
    }, 300);
  }

  suggest() {
    if (this.checkUserBanStatus()) {
      this.blogDataService.setUser(this.user);
      this.blogDataService.setSuggest(this.allSuggestedUsers);
      this.blogService.goToSuggest();
      this.tabBarShared.hideTabBar();
    }
    // this.blogShared.blogZIndex++;
    // this.showSuggest = true;
    // setTimeout(() => {
    //   document.getElementById('suggestPage').style.zIndex =
    //     this.blogShared.blogZIndex.toString();
    //   document.getElementById('suggestPage').style.right = '0';
    // }, 100);
  }

  closeSuggest() {
    this.blogShared.blogZIndex--;
    document.getElementById('suggestPage').style.right = '100%';
    // this._sharedService.animateDownButton();
    setTimeout(() => {
      this.tabBarShared.showTabBar();
      this.showSuggest = false;
    }, 300);
  }

  createPost(username) {
    // this.blogShared.blogZIndex++;

    if (username === '') {
      this.checkUsername();
    } else {
      if (this.checkUserBanStatus()) {
        this.blogDataService.setUser(this.user);
        this.tabBarShared.hideTabBar();
        this.showCreatePost = true;
        this.blogService.goTonewPost(this.user.userName);
      }
    }

    // setTimeout(() => {
    //   document.getElementById('createPostPage' + this.id).style.zIndex =
    //     this.blogShared.blogZIndex.toString();
    //   document.getElementById('createPostPage' + this.id).style.right = '0';
    // }, 100);
  }

  closeCreatePostButton() {
    this.blogShared.exitCreatePost();
  }

  closeCreatePost() {
    if (document.getElementById('createPostPage' + this.id)) {
      this.blogShared.blogZIndex--;
      document.getElementById('createPostPage' + this.id).style.right = '100%';
      // this._sharedService.animateDownButton();
      setTimeout(() => {
        this.tabBarShared.showTabBar();
        this.showCreatePost = false;
      }, 300);
    }
  }

  openDetail(index: number) {
    if (this.checkUserBanStatus()) {
      this.blogShared.blogZIndex++;
      this.detailId = this.blogShared.blogZIndex;
      this.selectedPost = this.posts[index];
      this.tabBarShared.hideTabBar();
      this.showDetail = true;
      setTimeout(() => {
        document.getElementById('botomsheet' + this.id).style.zIndex =
          this.blogShared.blogZIndex.toString();
        document.getElementById('botomsheet' + this.id).style.top = '0';
      }, 100);
    }
  }

  openDetailComments(index: number) {
    if (this.checkUserBanStatus()) {
      this.blogShared.blogZIndex++;
      this.detailId = this.blogShared.blogZIndex;
      this.selectedPost = this.posts[index];
      this.tabBarShared.hideTabBar();
      this.showDetail = true;
      setTimeout(() => {
        document.getElementById('botomsheet' + this.id).style.zIndex =
          this.blogShared.blogZIndex.toString();
        document.getElementById('botomsheet' + this.id).style.top = '0';
        this.blogShared.blogScrollToComments();
      }, 100);
    }
  }

  closeDetail() {
    this.blogShared.blogZIndex--;
    document.getElementById('botomsheet' + this.id).style.top = '100%';
    setTimeout(() => {
      this.tabBarShared.showTabBar();
      this.showDetail = false;
    }, 300);
  }

  openBlogWithTag() {
    if (this.checkUserBanStatus()) {
      this.blogShared.blogZIndex++;
      this.tagId = this.blogShared.blogZIndex;
      this.tabBarShared.hideTabBar();
      this.showBlogWithTag = true;
      setTimeout(() => {
        document.getElementById('blogWithTag' + this.id).style.zIndex =
          this.blogShared.blogZIndex.toString();
        document.getElementById('blogWithTag' + this.id).style.right = '0';
      }, 100);
    }
  }

  closeBlogWithTag() {
    this.blogShared.blogZIndex--;
    document.getElementById('blogWithTag' + this.id).style.right = '100%';
    setTimeout(() => {
      this.tabBarShared.showTabBar();
      this.showBlogWithTag = false;
    }, 300);
  }

  follow(user: BlogUserModel) {
    if (this.checkUsername() && this.checkUserBanStatus()) {
      this.blogService.follow(user.id).then((res) => {
        if (res.isSuccess()) {
          if (user.status === 'private') {
            this.blogShared.pendingSuggestedUsernames.push(user.userName);
          } else {
            this.blogShared.followedSuggestedUsernames.push(user.userName);
          }
        } else {
          this.snackBarService.showSnackBar('خطا در برقراری ارتباط با سرور!');
        }
      });
    }
  }

  unFollow(user: BlogUserModel) {
    if (this.checkUserBanStatus()) {
      this.blogService.follow(user.id).then((res) => {
        if (res.isSuccess()) {
          this.blogShared.followedSuggestedUsernames.splice(
            this.blogShared.followedSuggestedUsernames.indexOf(user.userName),
            1
          );
          this.blogShared.pendingSuggestedUsernames.splice(
            this.blogShared.pendingSuggestedUsernames.indexOf(user.userName),
            1
          );
        } else {
          this.snackBarService.showSnackBar('خطا در برقراری ارتباط با سرور!');
        }
      });
    }
  }

  checkUsername(): boolean {
    if (this.user.userName === '') {
      this.matBottomSheet.open(SetUsernameBottomsheetComponent, {
        panelClass: 'custom-bottomsheet-container',
      });
      return false;
    }
    return true;
  }

  scrollTop() {
    try {
      this.myScrollContainer.nativeElement.scrollTop = 0;
    } catch (err) {}
  }
}
